
const canvas = document.querySelector('#canvas');

if(canvas){
    const ctx = canvas.getContext('2d');

    // Resizing
    let canvasOffsetX = canvas.offsetLeft;
    let canvasOffsetY = canvas.offsetTop;
    canvas.height = window.innerHeight - canvasOffsetX;
    canvas.width = window.innerWidth - canvasOffsetY;
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    // Variables
    let painting = false;
    let lineWidth = 3;
    
    function startPosition(e){
        painting = true;
        draw(e);
    }
    
    function finishedPosition(){
        painting = false;
        ctx.beginPath();
    }
    
    function draw(e){
        if(!painting) return;
        ctx.lineWidth = lineWidth;
        ctx.lineCap = 'round';
    
        ctx.lineTo(e.clientX - canvasOffsetX, e.clientY - canvasOffsetY);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(e.clientX, e.clientY)
    }
    
    // Inputs
    const clearBtn = document.querySelector('#clear');
    const strokeBtn = document.querySelector('#stroke');
    const colorBtn = document.querySelector('#color');
    const fillBtn = document.querySelector('#fill');
    
    // Event listeners
    canvas.addEventListener('mousedown', startPosition);
    canvas.addEventListener('mouseup', finishedPosition);
    canvas.addEventListener('mousemove', draw);
    
    canvas.addEventListener('pointerdown', startPosition);
    canvas.addEventListener('pointerup', finishedPosition);
    canvas.addEventListener('pointermove', draw);
    
    clearBtn.addEventListener('click', () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    })
    
    ctx.strokeStyle = colorBtn.value;
    colorBtn.addEventListener('change', () => {
        ctx.strokeStyle = colorBtn.value;
    })
    
    lineWidth = strokeBtn.value;
    strokeBtn.addEventListener('change', () => {
        lineWidth = strokeBtn.value;
    })
    
    fillBtn.addEventListener('click', () => {
        ctx.fillStyle = colorBtn.value;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    })
    
    window.addEventListener('resize', () =>{
        canvasOffsetX = canvas.offsetLeft;
        canvasOffsetY = canvas.offsetTop;
        canvas.height = window.innerHeight - canvasOffsetX;
        canvas.width = window.innerWidth - canvasOffsetY;
    })
    
    
    // Download image
    const displayBtn = document.querySelector('#display');
    const dlBtn = document.querySelector('#download');
    const imgConverted = document.querySelector('#imgConverted')
    
    displayBtn.addEventListener('click', () => {
        const dataURL = canvas.toDataURL('image/jpeg');
        imgConverted.src = dataURL;
    })
    
    dlBtn.addEventListener('click', () => {    
        /**
        * Envoyer le canvas à PHP
        */
        // Récupérer les données de l'image en base64
        // (La variable "canvas" provient de plus haut dans le script et contient un canvas)
        const imgsrc = canvas.toDataURL("image/png");
        // Mettre les données dans un formData pour pouvoir les envoyer
        const formData = new FormData();
        formData.append('image', imgsrc);
        // Envoyer les données via Fetch au script save.php
        fetch("save.php", {
            method: "POST",
            body: formData,
        })
    })
}

const gallery = document.querySelector('#gallery');
if(gallery){
    const ctx = gallery.getContext('2d');
    gallery.height = 300;
    gallery.width = 300;
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, gallery.width, gallery.height);


    let columns = 6;
    let rows = 6;

    let tileWidth  = gallery.width / columns;
    let tileHeight = gallery.height / rows;

    let xIndex = 0;
    let yIndex = 0;

    let xTile = xIndex * tileWidth;
    let yTile = yIndex * tileHeight;
    
    gallery.addEventListener('mousemove', (e) => {
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, gallery.height, gallery.width);
        let cursorPos = gallery.getBoundingClientRect();
        let mx = e.clientX - cursorPos.left;
        let my = e.clientY - cursorPos.top;

        xIndex = Math.floor(mx / tileWidth),
        yIndex = Math.floor(my / tileHeight);

        xTile = xIndex * tileWidth;
        yTile = yIndex * tileHeight;
        ctx.fillStyle = 'cadetblue';
        ctx.fillRect(xTile, yTile, tileWidth, tileHeight);
    })

    gallery.addEventListener('click', () => {
        window.open('http://localhost:3000?x='+ xIndex + '&y=' + yIndex, "_self");
    })
}
